module.exports = __webpack_public_path__ + "static/media/tgo-icon.5fdaa5b7.svg";